"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.TimingType = exports.SumoLogger = exports.ActionType = void 0;
var ActionType = exports.ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["leftClick"] = "left click";
  ActionType["rightClick"] = "right click";
  ActionType["middleClick"] = "middle click";
  ActionType["unknownClick"] = "unknown click";
  return ActionType;
}({});
var TimingType = exports.TimingType = /*#__PURE__*/function (TimingType) {
  TimingType["pageLoad"] = "page load";
  TimingType["focusTime"] = "focus time";
  TimingType["computationTime"] = "computation time";
  TimingType["ajax"] = "ajax";
  return TimingType;
}({});
var SumoLogger = exports.SumoLogger = function SumoLogger(queue) {
  var addToQueue = function addToQueue(logObject, logUrl) {
    queue.addToLogQueue(logObject, logUrl);
  };
  var logAction = function logAction(actionType, target, additionalKeyPairs) {
    var logUrl = '/rum/genesis-dev-client-logging?';
    var logObject = additionalKeyPairs || {};
    logObject.actionType = actionType;
    logObject.target = target;
    addToQueue(logObject, logUrl);
  };
  var logTiming = function logTiming(timingType, timingId, measure, additionalKeyPairs) {
    var logUrl = '/rum/genesis-dev-client-timings?';
    var logObject = additionalKeyPairs || {};
    logObject.timingType = timingType;
    logObject.timingId = timingId;
    logObject.measure = measure;
    addToQueue(logObject, logUrl);
  };
  var logError = function logError(errorMessage, additionalKeyPairs) {
    var logUrl = '/rum/genesis-dev-client-errors?';
    var logObject = additionalKeyPairs || {};
    logObject.error = errorMessage;
    addToQueue(logObject, logUrl);
  };
  return {
    logAction: logAction,
    logTiming: logTiming,
    logError: logError
  };
};
//# sourceMappingURL=sumoService.js.map